/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {handleThreeDSChallengeOutcome} from '../api'

export const useMutationHandleThreeDSChallengeOutcome = createReactQueryMutationHook('handleThreeDSChallengeOutcome', handleThreeDSChallengeOutcome)
